module.exports = __webpack_public_path__ + "img/麻黄.017db970.jpg";